import TextField from "@mui/material/TextField";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import { Add } from "@mui/icons-material";
import { useContext, useEffect, useState } from "react";
import { useTheme } from "@emotion/react";
import { useMediaQuery } from "@mui/material";
import { SnackAlertContext } from "../../../../context/SnackAlertContext";
import { AuthContext } from "../../../../context/AuthContext";
import CreateProjectDialog from "../../Customers/CreateProjectDialog";

const filter = createFilterOptions();

const SelectProject = ({
  companyId,
  value,
  label = "Project",
  onUpdate,
  disabled,
  enableAdd,
  onBlur,
  error,
  helperText,
  required,
  ...props
}) => {
  const { openSnackMessage } = useContext(SnackAlertContext);
  const { ezorder, authToken } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [projects, setProjects] = useState([]);
  const [open, toggleOpen] = useState(false);
  const [dialogValue, setDialogValue] = useState("");

  const getProjects = async () => {
    try {
      setLoading(true);
      const response = await ezorder.get(
        `/admin/customers/${companyId}/projects`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status == 200 || response.status == 201) {
        setProjects(response.data.projects);
      } else {
        openSnackMessage("error", response.response.data.error);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setDialogValue("");
    toggleOpen(false);
  };

  useEffect(() => {
    if (disabled || !companyId) {
      setProjects([]);
    } else {
      getProjects();
    }
  }, [disabled, companyId]);

  return (
    <>
      <Autocomplete
        value={value}
        disabled={disabled}
        handleHomeEndKeys
        onChange={(event, newValue) => {
          // console.log("newValue", event, newValue);
          // When the user types then presses "enter" key
          if (enableAdd && typeof newValue === "string") {
            // timeout to avoid instant validation of the dialog's form.
            // console.log("Value is string");
            setTimeout(() => {
              toggleOpen(true);
              setDialogValue(newValue.name);
            });
          }
          // When User types then clicks 'Add "inputText"'
          else if (enableAdd && newValue && !newValue.id) {
            // console.log("Value isnt string but no id");
            toggleOpen(true);
            setDialogValue(newValue.name);
          }
          // When User Selects and Option (Object) or Clicks the clear button (null)
          else {
            // console.log("Value is object or null", newValue);
            // console.log("SET VALUE", newValue);
            if (onUpdate) onUpdate(newValue ?? null);
          }
        }}
        onInputChange={() => {
          // console.log("onInputChange");
        }}
        filterOptions={(options, params) => {
          const filtered = filter(options, params);

          if (enableAdd && params.inputValue !== "") {
            filtered.push({
              id: undefined,
              name: params.inputValue,
            });
          }

          return filtered;
        }}
        options={projects}
        getOptionLabel={(option) => {
          //   console.log("Option", option);
          // for example value selected with enter, right from the input
          if (typeof option === "string") {
            return option;
          }
          if (option.inputValue) {
            return option.inputValue;
          }
          return option.name;
        }}
        selectOnFocus
        clearOnBlur
        isOptionEqualToValue={(option, value) => {
          //  The "selected" prop on renderOption depends on this
          return value.name == option.name;
        }}
        renderOption={(props, option, { selected }) => {
          const { key, ...optionProps } = props;

          if (option.id)
            return (
              <li key={key} {...optionProps}>
                {option.name}
              </li>
            );
          else
            return (
              <li key={key} {...optionProps}>
                <Add style={{ marginRight: 8 }} />

                {option.id ? option.name : `Add "${option.name}"`}
              </li>
            );
        }}
        freeSolo
        renderInput={(params) => (
          <TextField
            disabled={disabled}
            {...params}
            size={props.size ? props.size : "small"}
            label={label}
            sx={{
              width: "100%",
            }}
            variant="outlined" // filled, outlined, standard
            InputProps={{
              ...params.InputProps,
              onKeyDown: (e) => {
                if (!enableAdd && e.key === "Enter") {
                  e.stopPropagation();
                }
              },
              endAdornment: <>{params.InputProps.endAdornment}</>,
            }}
            onBlur={onBlur}
            error={error}
            helperText={helperText}
            required={required}
          />
        )}
      />

      <CreateProjectDialog
        companyId={companyId}
        open={open}
        defaultProjectName={dialogValue}
        handleClose={handleClose}
        onSuccess={async (newProject) => {
          // Refresh Data
          await getProjects();
          // Set Created as Value
          onUpdate(newProject);
          // Close Dialog
          handleClose();
        }}
      />
    </>
  );
};

export default SelectProject;

// import { Autocomplete, TextField } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import SelectProjectDialog from "./SelectProjectDialog";

// const SelectProject = ({ selectedCompany, project, onSelect }) => {
//   const [open, setOpen] = useState(false);
//   return (
//     <>
//       <TextField
//         fullWidth
//         size="small"
//         disabled={selectedCompany == null || selectedCompany == undefined}
//         label={
//           selectedCompany && selectedCompany.isVendorOrSupplier
//             ? "Vendor/Supplied Customer Name"
//             : "Project"
//         }
//         inputProps={{ readOnly: true }}
//         value={project ? project.name : ""}
//         onClick={() => {
//           if (selectedCompany) setOpen(true);
//         }}
//       />
//       {selectedCompany && (
//         <SelectProjectDialog
//           selectedCompany={selectedCompany}
//           open={open}
//           handleClose={() => {
//             setOpen(false);
//           }}
//           onSelect={onSelect}
//         />
//       )}
//     </>
//   );
// };

// export default SelectProject;
